module.exports = __webpack_public_path__ + "img/yellow.67521935.jpg";